module.exports = __webpack_public_path__ + "static/media/cellphone-error.c2872554.svg";